import React, { useContext, useMemo } from "react";
import { CommandBarButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { OnPremOrderListingContext } from "../context/OnPremOrderListingContext";
import { OnPremOrderListingItem } from "../OnPremOrderListingItem";

export const PinOnPremOrderButton: React.VFC = () => {
    const { selectedItems, togglePinnedOnPremOrder } = useContext(OnPremOrderListingContext);
    const allArePinned = useMemo(() => selectedItems.every((item) => item.isPinned), [selectedItems]);

    const handlePinOrders = () => {
        if (allArePinned) {
            pinSelectedOrders(selectedItems);
        } else {
            const unpinnedItems = selectedItems.filter((item) => !item.isPinned);
            pinSelectedOrders(unpinnedItems);
        }
    };

    const pinSelectedOrders = (orders: OnPremOrderListingItem[]) => {
        orders.forEach((item) => togglePinnedOnPremOrder(item.id));
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdReadWrite]}>
            <CommandBarButton
                text={allArePinned ? "Unpin" : "Pin"}
                icon="Pinned"
                disabled={!selectedItems.length}
                onClick={handlePinOrders}
            />
        </AuthorizationWrapper>
    );
};
